import { Component, Input } from '@angular/core';

@Component({
  selector: 'ti-lock-status',
  template: `<div *ngIf="trackeritem.lockStatus === 1" class="alert alert-danger" role="alert">
              <i class="glyphicon glyphicon-lock notice"></i>
              <span translate>This ticket is locked for editing.</span>
            </div>

            <div *ngIf="trackeritem.lockStatus === 2" class="alert alert-warning" role="alert">
              <i class="glyphicon glyphicon-lock notice"></i>
              <span translate>This ticket is locked for editing. Only new follow-ups are allowed.</span>
            </div>

            <div *ngIf="trackeritem.lockStatus === 0 && !acls.canUpdate && acls.canFollowup" class="alert alert-info" role="alert">
              <i class="glyphicon glyphicon-info-sign notice"></i>
              <span translate>You can add a follow-up comment to this Tracker Item on the Timeline tab.</span>
            </div>`
})
export class LockStatusComponent {
  @Input() trackeritem: any;
  @Input() acls: any;

  constructor() { }
}
